/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { ModalProps } from '..'
import { Button, Input, Modal } from '../../components'
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { showError } from '../../utils/error';
import { addCustomCity, updateCustomCity } from '../../services/Organization.service';
import toast from 'react-hot-toast';
import { ICity } from '../../types';

interface Props extends ModalProps {
    refetch: () => void;
    editableCity?: ICity | null;
}

const schema = yup.object({
    name: yup.string().required('Please enter city name')
})

const AddCustomCity: React.FC<Props> = ({
    open,
    onClose,
    refetch,
    editableCity
}) => {
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm({
        resolver: yupResolver(schema)
    })

    useEffect(() => {
        if (editableCity) {
            setValue('name', editableCity.city)
        }
    }, [editableCity])

    const onSubmit = useCallback(async (values: { name: string }) => {
        setLoading(true);
        try {
            if (editableCity) {
                const res = await updateCustomCity(editableCity?._id, values);
                toast.success(res?.message);
            } else {
                const res = await addCustomCity(values);
                toast.success(res?.message);
            }
            refetch();
            onClose();
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    }, [onClose, refetch, editableCity])

    return (
        <Modal
            open={open}
            onClose={onClose}
            showClose={true}
            title={`${editableCity ? 'Update' : 'Add'} custom city`}
            loading={loading}
        >
            <form style={{ marginTop: '20px' }} onSubmit={handleSubmit(onSubmit)}>
                <Input
                    fullWidth
                    label='City name'
                    placeholder='Enter here'
                    {...register("name")}
                    error={!!errors.name}
                    helperText={errors.name?.message}
                />
                <Button fullWidth type='submit' sx={{ mt: 4 }} loading={loading}>{editableCity ? 'Update' : 'Save'}</Button>
            </form>
        </Modal>
    )
}

export default AddCustomCity